<template>
  <transition name="move">
    <div class="recommend-job-container" v-if="recommendState" data-growing-container id="1">
      <div class="recommend-job-header">
        <i class="iconfont iconx"  @click="toEmailExport"/>
      </div>
      <div class="recommend-job-info">
        <div class="flex-start ">
          <img class="job-info-hr-avatar" :src="jobData.hr_avatar" alt="">
          <div class="flex-column">
            <span class="job-info-hr-name">{{ jobData.hr_name }}</span>
            <span class="job-info-company">{{ `${ jobData.company && jobData.company.company_nick_name } · ${ jobData.job_post }` }}</span>
          </div>
        </div>
        <div class="apply-msg">{{ jobData.apply_message }}</div>
        <div class="job-info">
          <div class="flex-between job-post-content">
            <span class="job-info-post">{{ jobData.job_post }}</span>
            <span class="job-info-salary">{{ jobData.salary }}</span>
          </div>
          <div class="flex-start job-demand">
            <span class="job-info-city flex-center">{{ jobData.city }}</span>
            <span class="job-info-experience flex-center">{{ jobData.experience }}</span>
            <span class="job-info-degree flex-center">{{ jobData.degree }}</span>
          </div>
          <div class="flex-start" v-if="jobData.company">
            <img class="company-logo" :src="jobData.company.logo" alt="">
            <span class="company-nick-name">{{ jobData.company.company_nick_name }}</span>
          </div>
        </div>
      </div>
      <div class="bottom-btn">
        <button class="theme-button flex-center" @click="deliverJob">接受邀约并保存</button>
      </div>
      <w-loading v-if="loadingState" :show-text="true" />
    </div>
  </transition>
</template>

<script>
  import WLoading from '../../../components/global/w-loading'
  import { componentsMixin } from "../../../assets/js/mixin/components";
  import { reportedData } from '../../../assets/js/mixin/io'
  import { mapState } from 'vuex'

  export default {
    name: 'recommend-job-cv',
    mixins: [ componentsMixin ],
    props: {
      recommendState: {
        type: Boolean,
        default: false
      },
      jobData: {
        type: Object,
        default: () => {}
      },
      hideProfile: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        loadingState: false
      }
    },
    mounted() {
    },
    computed: {
      ...mapState('cv', [ 'cv' ])
    },
    watch: {},
    components: {
      WLoading
    },
    methods: {
      async deliverJob() {
        try {
          let { token } = this.$route.params
          let { job_token, origin_source } = this.jobData
          let payload = {
            cv_token: token
          }
          this.loadingState = true
          if (origin_source === 'jd') {
            let urlRes = await this.$api.cv.downloadCv(token, { watermark: 'yes' })
            if (urlRes.code === 1000) payload.cv_url = urlRes.data.url
          }
          let res = await this.$api.jobs.jobDelivery(job_token, payload)
          if (res.code === 1000) {
            this.reportedData({
              data_type: 'job_delivery',
              data: {
                job_tokens: [ jobToken ],
                record_key: 'exportJobDelivery',
                record_url: window.location.href
              }
            })
            this.loadingState = false
            this.showToast('投递成功')
            this.handleClose()
            setTimeout(() => {
              this.toEmailExport()
            }, 500)
          } else {
            this.loadingState = false
            this.showToast('投递失败，请重试')
          }
        } catch (e) {
          this.loadingState = false
          console.log(e)
        }
      },
      handleClose() {
        this.$db.ls.set('isDownloadCvJob', true)
        this.$emit('handleClose')
      },
      toEmailExport() {
        this.handleClose()
        let { basic_info: { cv_name, token } } = this.cv
        setTimeout(() => {
          this.$router.push(`/cvs/send-email?token=${ token }&cv_name=${ cv_name }&hideProfile=${ this.hideProfile }`)
        }, 200)
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "../../../assets/scss/global/variable";
  @import "../../../assets/scss/global/mixin";
  .move-enter-active,
  .move-leave-active {
    transition: all 0.2s;
  }
  .move-enter,
  .move-leave-to {
    transform: translate3d(0, 100%, 0);
  }
  .recommend-job {
    &-container {
      width: 100vw;
      height: $screen-height;
      position: fixed;
      top: 0;
      left: 0;
      background-color: $color-light;
      z-index: 13;
    }
    &-header {
      padding: 24px 24px 14px;
      i {
        color: $color-title;
        font-size: 22px;
        font-weight: bold;
      }
    }
    &-info {
      padding: 44px 24px;
    }
  }
  .recommend-job-info {
    padding: 20px;
    .job-info-hr-avatar {
      width: 52px;
      height: 52px;
      border-radius: 50%;
      object-fit: contain;
      margin-right: 12px;
    }
    .job-info-hr-name {
      font-size: $font-size-medium-x;
      color: $color-title;
      margin-bottom: 8px;
    }
    .job-info-company {
      font-size: $font-size-large;
      color: $color-title;
      font-weight: 500;
    }
    .apply-msg {
      $width: calc(100vw - 48px);
      @include bubble($width, 72px, #f9f9f9, 1);
      padding: 12px 18px;
      margin-top: 16px;
      line-height: 24px;
      color: $color-title;
      &:before {
        top: auto;
        bottom: 100%;
        left: 24px;
        transform: translateX(0);
        border-top: 9px solid transparent;
        border-bottom: 8px solid #f9f9f9;
      }
    }
    .job-info {
      margin-top: 24px;
      padding: 20px;
      border-radius: 12px;
      box-shadow: 0 2px 14px 0 rgba($color: #000000, $alpha: .06);
      .job-post-content {
        margin-bottom: 16px;
        .job-info-post {
          font-size: $font-size-medium-x;
          color: $color-title;
          font-weight: 500;
        }
        .job-info-salary {
          font-size: $font-size-medium-x;
          color: $color-theme;
          font-weight: 500;
        }
      }
      .job-demand {
        margin-bottom: 12px;
        span {
          color: $color-title;
          &::after {
            content: '';
            width: 1px;
            height: 10px;
            background-color: #ececec;
            margin: 0 6px;
          }
          &:last-child::after {
            display: none;
          }
        }
      }
      .company-logo {
        width: 24px;
        height: 24px;
        border-radius: 4px;
        border: 1px solid #f9f9f9;
        object-fit: contain;
        margin-right: 10px;
      }
      .company-nick-name {
        color: $color-title;
      }
    }
  }
  .bottom-btn {
    width: 100vw;
    position: fixed;
    @include fixed-bottom(38px);
    padding: 0 24px;
    button {
      width: 100%;
      height: 46px;
      border-radius: 24px;
      font-size: $font-size-medium-x;
    }
  }
</style>
